import { CSSProperties } from 'react'
import { createTheme, ThemeOptions } from '@mui/material'
import * as locales from '@mui/material/locale'
import _ from 'lodash'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwind from '~root/tailwind.config.js'

const tailwindConfig = resolveConfig(tailwind)

export enum ThemeMode {
  Dark = 'dark',
  Light = 'light',
}

const common = {
  typography: {
    fontFamily: tailwindConfig.theme.fontFamily.sans.join(','),
    h1: {
      // fontSize: '6rem', / 28px
      fontSize: 'clamp(1.75rem, -0.511rem + 7.234vw, 6rem)',
    },
    h2: {
      // fontSize: '3.75rem', / 24px
      fontSize: 'clamp(1.5rem, 0.303rem + 3.83vw, 3.75rem)',
    },
    h3: {
      // fontSize: '3rem', / 22px
      fontSize: 'clamp(1.375rem, 0.511rem + 2.766vw, 3rem)',
    },
    h4: {
      // fontSize: '2.125rem', / 20px
      fontSize: 'clamp(1.25rem, 0.785rem + 1.489vw, 2.125rem)',
    },
    h5: {
      // fontSize: '1.5rem', / 18px
      fontSize: 'clamp(1.125rem, 0.926rem + 0.638vw, 1.5rem)',
    },
    h6: {
      // fontSize: '1.25rem' / 16px
      fontSize: 'clamp(1rem, 0.867rem + 0.426vw, 1.25rem)',
    },
    small: {
      fontSize: '0.8em',
    },
  },
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    annotation: CSSProperties
  }

  // allow configuration using `createTheme()`
  interface TypographyVariantsOptions {
    annotation?: CSSProperties
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    annotation: true
  }
}

// https://mui.com/material-ui/customization/default-theme/
const createThemeByMode = (mode: ThemeMode) => {
  const theme = createTheme(
    _.merge(common, {
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              whiteSpace: 'nowrap',
              textTransform: 'none',
            },
          },
        },
        MuiTooltip: {
          styleOverrides: {
            tooltip: {
              textAlign: 'center',
            },
          },
        },
        MuiTypography: {
          defaultProps: {
            variantMapping: {
              // h1: 'h2',
              // h2: 'h2',
              // h3: 'h2',
              // h4: 'h2',
              // h5: 'h2',
              // h6: 'h2',
              // subtitle1: 'h2',
              // subtitle2: 'h2',
              // body1: 'span',
              // body2: 'span',
              annotation: 'p',
            },
          },
        },
      },
      palette: {
        mode,
      },
      typography: {
        annotation: {
          fontSize: '0.8rem',
          opacity: 0.5,
        },
      },
    }) as object as ThemeOptions,
    locales.plPL
  )
  return theme
}

export default createThemeByMode
